import {Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[onInitDirective]'
})
export class OnInitDirective implements OnInit {

  @Input('onInitDirective') onInitDirective: Function;

  constructor() {}

  public ngOnInit(): void {
    if (this.onInitDirective) {
      this.onInitDirective();
    }
  }

}